import { render } from "./IconArrowRight.vue?vue&type=template&id=1cade8da"
import script from "./IconArrowRight.vue?vue&type=script&lang=ts"
export * from "./IconArrowRight.vue?vue&type=script&lang=ts"
script.render = render

export default script